import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Control } from 'commons/js/ui/Input'

import {
    required,
} from 'commons/js/util/validators'

import messages from './messages'

class NameField extends React.PureComponent {
    static propTypes = {
        intl: PropTypes.object,
    }

    render () {
        const { intl } = this.props
        return (
            <Control
              dataTest='contact-form-name'
              id='.name'
              model='.name'
              validators={{
                  required: required(),
              }}
              validateIcon
              placeholder={intl.formatMessage(messages.namePlaceholder)}
              autoComplete='off'
              errorMessages={{
                  required: intl.formatMessage(messages.requiredError),
              }}
              label={intl.formatMessage(messages.nameLabel)}
              debounce={250}
            />
        )
    }
}

export default injectIntl(NameField)
